/**
 * @param {object} state
 * @param {object} style
 */
const addStyle = (state, style) => {
  const index = state.styles.length

  state.styles.splice(index, 1, style)
}

/**
 * @param {object} state
 * @param {number} styleId
 */
const deleteStyle = (state, styleId) => {
  const index = state.styles.findIndex(style => style.id === styleId)

  state.styles.splice(index, 1)
}

/**
 * @param {object} state
 * @param {object} style
 */
const updateStyle = (state, style) => {
  const index = state.styles.findIndex(b => b.id === style.id)

  const updatedStyle = {
    ...state.styles[index],
    ...style
  }

  state.styles.splice(index, 1, updatedStyle)
}

/**
 * @param {object}   state
 * @param {object[]} tags
 */
const setCustomTags = (state, tags) => {
  state.customTags = tags
}

/**
 * @param {object} state
 * @param {object} tag
 */
const addCustomTag = (state, tag) => {
  const index = state.customTags.length

  state.customTags.splice(index, 1, tag)
}

/**
 * @param {object} state
 * @param {object} styleMetaFilters
 */
const setStyleMetaFilters = (state, styleMetaFilters) => {
  state.styleMetaFilters = styleMetaFilters
}

/**
 * @param {object} state
 * @param {object} styleHubFilters
 */
const setStyleHubFilters = (state, styleHubFilters) => {
  state.styleHubFilters = styleHubFilters
}

/**
 * @param {object} state
 */
const resetStylesPaginated = state => {
  state.stylesPaginatedPage = 1
  state.styles = []
  state.hasReachedStylesPaginatedEnd = false
}

/**
 * @param {object} state
 */
const incrementStylesPaginatedPage = state => {
  state.stylesPaginatedPage++
}

/**
 * @param {object}  state
 * @param {boolean} hasReachedStylesPaginatedEnd
 */
const setHasReachedStylesPaginatedEnd = (
  state,
  hasReachedStylesPaginatedEnd
) => {
  state.hasReachedStylesPaginatedEnd = hasReachedStylesPaginatedEnd
}

/**
 * @type {object}
 */
const mutations = {
  addStyle,
  deleteStyle,
  updateStyle,
  setCustomTags,
  addCustomTag,
  setStyleMetaFilters,
  setStyleHubFilters,
  incrementStylesPaginatedPage,
  resetStylesPaginated,
  setHasReachedStylesPaginatedEnd
}

export default mutations
